import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MobileAppComponent } from './mobile-app.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    MobileAppComponent,
  ],
  providers: [
  ]
})
export class MobileAppModule { }



// WEBPACK FOOTER //
// ./src/app/mobile-app/mobile-app.module.ts